/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserWithRolesDto } from './UserWithRolesDto';
import {
    UserWithRolesDtoFromJSON,
    UserWithRolesDtoFromJSONTyped,
    UserWithRolesDtoToJSON,
    UserWithRolesDtoToJSONTyped,
} from './UserWithRolesDto';

/**
 * 
 * @export
 * @interface UserWithRolesDtoPagedResponseDto
 */
export interface UserWithRolesDtoPagedResponseDto {
    /**
     * 
     * @type {Array<UserWithRolesDto>}
     * @memberof UserWithRolesDtoPagedResponseDto
     */
    items?: Array<UserWithRolesDto> | null;
    /**
     * 
     * @type {number}
     * @memberof UserWithRolesDtoPagedResponseDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof UserWithRolesDtoPagedResponseDto
     */
    pageIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof UserWithRolesDtoPagedResponseDto
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the UserWithRolesDtoPagedResponseDto interface.
 */
export function instanceOfUserWithRolesDtoPagedResponseDto(value: object): value is UserWithRolesDtoPagedResponseDto {
    return true;
}

export function UserWithRolesDtoPagedResponseDtoFromJSON(json: any): UserWithRolesDtoPagedResponseDto {
    return UserWithRolesDtoPagedResponseDtoFromJSONTyped(json, false);
}

export function UserWithRolesDtoPagedResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserWithRolesDtoPagedResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(UserWithRolesDtoFromJSON)),
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'pageIndex': json['pageIndex'] == null ? undefined : json['pageIndex'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function UserWithRolesDtoPagedResponseDtoToJSON(json: any): UserWithRolesDtoPagedResponseDto {
    return UserWithRolesDtoPagedResponseDtoToJSONTyped(json, false);
}

export function UserWithRolesDtoPagedResponseDtoToJSONTyped(value?: UserWithRolesDtoPagedResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(UserWithRolesDtoToJSON)),
        'totalCount': value['totalCount'],
        'pageIndex': value['pageIndex'],
        'pageSize': value['pageSize'],
    };
}

